import React from "react"
import moment from "moment"
import { Badge } from "../ui/badge"
import { getOrdinal } from "../../utils/get-ordinal"
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
} from "@radix-ui/react-popover"
import { ServiceTypes } from "../../data/service-types"

interface Props {
  service: any
}

const ServiceCardBannerOverlay: React.FC<Props> = ({ service }) => {
  const { service_details, is_group_service } = service
  const { type } = service_details
  const { Icon, title, description } = ServiceTypes[type]

  const getStartDateMessage = (): string | undefined => {
    const group = service_details.group
    if (!group) return

    const userTz = moment.tz.guess()

    if (group.startDate) {
      return `Starts on ${moment
        .tz(group.startDate, userTz)
        .format("MMM DD, YYYY")}`
    }

    const meetingDates = group.meetingDates || []
    const sessionCount = meetingDates.length

    if (sessionCount === 0) {
      return "No sessions available"
    } else {
      const date = meetingDates[0]
      const isPast = new Date(date) < new Date()
      const formattedDate = moment
        .tz(date, userTz)
        .format("MMM DD [at] h:mm A z")
      const sessionLabel = getOrdinal(1)
      const sessionStatus = isPast ? "was" : "Scheduled for"
      return `${sessionLabel} Session ${sessionStatus} ${formattedDate}`
    }
  }

  const startDateMessage = getStartDateMessage()

  return (
    <Popover>
      <div className="flex flex-col items-start gap-2 absolute top-12 left-4">
        <PopoverTrigger
          onClick={(e) => e.stopPropagation()}
          className="flex flex-col items-start"
        >
          <Badge variant="secondary" className="mr-2 mb-2 absolute -top-8">
            <Icon className="mr-1" />
            {title}
          </Badge>
          {is_group_service && startDateMessage && (
            <div className="mb-1 w-max">
              <Badge variant="success">{startDateMessage}</Badge>
            </div>
          )}
        </PopoverTrigger>
      </div>
      <PopoverContent
        side="bottom"
        className="flex flex-col items-center rounded-xl gap-3 bg-[#F8F8F8] p-3"
      >
        <Icon className="h-6 w-6 mx-auto" />
        <h3 className="font-bold text-[16px] md:text-[18px] md:mb-[8px] text-center">
          {title}
        </h3>
        <p className="md:text-center w-[310px] text-base text-graySlate mb-[16px] md:mb-[24px]">
          {description}
        </p>
      </PopoverContent>
    </Popover>
  )
}

export default ServiceCardBannerOverlay
